export default __webpack_public_path__ + "static/media/rain.bd483b86.svg";